/**
 * Registry of legacy paths that trigger redirect-usage telemetry.
 *
 * The actual redirect route definitions live in `behandelaar-redirects.ts`
 * (and any other domain-specific redirect modules wired into the router).
 * This file only enumerates the path patterns the router's `afterEach`
 * hook watches so it can log when a legacy URL is hit.
 *
 * DEPRECATION PLAN:
 * - Added: April 2026
 * - Tracking: Router logs redirects to console (search for "[Router] Legacy redirect:")
 * - Review: Check usage metrics monthly
 * - Removal: After 6 months with zero hits (October 2026)
 */
export const legacyRedirectPaths = new Set<string>([
  // /instellingen/* routes
  '/instellingen/rollen/nieuw',
  '/instellingen/rollen/:roleId',
  '/instellingen/brieftemplates',
  '/instellingen/brieftemplates/nieuw',
  '/instellingen/brieftemplates/:id/bewerken',
  // /settings/* routes
  '/settings/roles/new',
  '/settings/roles/:roleId',
  '/settings/letter-templates',
  '/settings/letter-templates/new',
  '/settings/letter-templates/:id/edit',
  '/settings/signaleringen',
  '/settings/signal-definitions',
  // /organization/* Dutch subpaths
  '/organization/afspraaktypes',
  '/organization/afspraaktypes/:appointmentTypeId',
  '/organization/clientstatussen',
  '/organization/clientstatussen/:clientStateId',
  // /formulieren/* routes
  '/formulieren',
  '/formulieren/:id',
  // /clients/:clientId/* Dutch routes
  '/clients/:clientId/zorgtrajecten',
  '/clients/:clientId/zorgtrajecten/:zorgtrajectId',
  '/clients/:clientId/financiering',
  '/clients/:clientId/dossier/overzicht',
  '/clients/:clientId/dossier/documenten',
  '/clients/:clientId/dossier/verslagen',
  '/clients/:clientId/dossier/verslagen/:reportId',
  '/clients/:clientId/dossier/afspraken',
  '/clients/:clientId/dossier/afspraken/:appointmentId',
  '/clients/:clientId/dossier/antwoorden',
  // /mijn-agenda/* routes
  '/mijn-agenda',
  '/mijn-agenda/:appointmentId',
  // /facturen and /declaraties/* routes
  '/facturen',
  '/declaraties',
  '/declaraties/zorgverzekeraar',
  '/declaraties/batches',
  '/declaraties/particulier',
  '/declaraties/facturen',
  '/declaraties/vecozo',
  '/declaraties/brief',
  '/declaraties/brief/openstaand',
  '/declaraties/brief/facturen',
  '/declaraties/brief/verstuurd',
  '/declaraties/brief/verwerkt',
  '/declaraties/uitstaand',
  '/declaraties/verwerkt',
])
